import { merge } from 'lodash-es';
import { track, trackOn } from '@updater-core/lib/tracker';
import { trackEngagement } from '@mover-app/engagement';
import { getVariation, isFeatureEnabled } from '@updater-core/lib/optimizely';
import { actions, selectors } from '../../../state';
import { ITEM_KINDS, ITEM_STATUSES } from '../../../constants/items';
import { STATES } from '../../../constants/states';
import { introRenderer } from './intro';
import { BASE_PATH } from './constants';
import { IS_IE, ITEM_DEFINITION_CODES } from '../../../constants';

function updateItemStatus(updStore) {
  const state = updStore.getState();
  const item = selectors.current.findItemByKind(
    ITEM_KINDS.HOME_SERVICES_APP,
    state
  );

  updStore.dispatch(
    actions.item
      .singleton(item.id(state))
      .update({ status: ITEM_STATUSES.RESERVED })
  );
}

const getState = (store) => selectors.homeServices.getAppData(store.getState());

export class HomeServicesController {
  constructor(
    updEnvironment,
    updStore,
    $element,
    $scope,
    $state,
    $stateParams,
    appShell
  ) {
    'ngInject';

    Object.assign(this, {
      updEnvironment,
      updStore,
      $element,
      $scope,
      $state,
      $stateParams,
      appShell,
    });
  }

  $onInit() {
    const { subscribe } = this.updStore;
    const { siteBranding } = this.appShell.interactors;

    const siteBrandingState = siteBranding.getState();
    const brandingDisplayName = siteBranding.selectors.brandingDisplayName(
      siteBrandingState
    );

    import(/* webpackChunkName: "home-services" */ './app').then(
      async ({ homeServicesApp }) => {
        const appElement = this.$element[0].querySelector(
          '#upd-home-services-app'
        );

        let pageName = '';
        const domain = 'home_services';

        const generateEvent = (attributes) =>
          merge(
            {},
            {
              domain,
              page: {
                name: pageName,
              },
              provider: {
                type: selectors.homeServices.providerType(
                  this.updStore.getState()
                ),
              },
            },
            attributes
          );

        const trackOff = trackOn(appElement, generateEvent);

        this.$scope.$on('$destroy', trackOff);

        const tracker = {
          track: (attributes) => track(generateEvent(attributes)),
        };

        const experiments = {
          getVariation: (experimentKey, attributes, activate) =>
            getVariation(experimentKey, attributes, activate),
        };

        const features = {
          isFeatureEnabled: (feature, attributes) =>
            isFeatureEnabled(feature, attributes),
        };

        const getOffers = () =>
          selectors.homeServices.searchHomeServicesOffers(
            this.updStore.getState()
          );
        const next = () => {
          const nextStep = selectors.step.nextStep(this.updStore.getState());
          this.updStore.dispatch(actions.step.goToNext(nextStep));
        };

        const { dispatch } = this.updStore;

        const appDestroy = homeServicesApp(appElement, {
          basePath: BASE_PATH,
          IS_IE,
          env: this.updEnvironment,
          brandingDisplayName,
          tracker,
          experiments,
          features,
          dispatch,
          getOffers,
          getAvailableProviders: new Promise((resolve) => {
            const offers = getOffers();

            if (offers) {
              resolve(offers.availableProviders || []);
            } else {
              const unsubscribe = subscribe(() => {
                const offers = getOffers();

                if (offers) {
                  resolve(offers.availableProviders || []);
                  unsubscribe();
                }
              });
            }
          }),
          ...getState(this.updStore),
          next,
          introRenderer: this.$stateParams.showIntroBanner
            ? introRenderer
            : () => {},
          onRouteChange: (route) => {
            pageName = route;
          },
          onReservation: () => {
            updateItemStatus(this.updStore);
          },
          goToCheckout: (params = { path: 'checkout' }) => {
            dispatch(
              actions.router.stateGo(STATES.STEP_HOME_SERVICES_CHECKOUT, params)
            );
          },
        });

        trackEngagement({
          name: 'TV/Internet',
          code: ITEM_DEFINITION_CODES.HOME_SERVICE_APP,
        });

        this.$scope.$on('$destroy', () => {
          if (appDestroy) appDestroy();
        });
      }
    );
  }
}
